import React from 'react';
import Typography from '@material-ui/core/Typography';

export default function Page404() {
  return (
    <Typography component="h1" variant="h5">
      Ops, página não econtrada.
    </Typography>
  );
}